export default __webpack_public_path__ + "a60d31ddb413419bbb7779c13cdaf5bc.jpg";